export const RIDER_JOB_TYPES = {
  FULL_TIME: 'full_time',
  PART_TIME: 'part_time',
  FREELANCE: 'freelance',
};
